import React from "react";
import {
  Button,
  Callout,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
  Intent
} from "@blueprintjs/core";

import FormInfo from "../../atoms/FormInfo/FormInfo";
import { useHistory } from "react-router-dom";
import styles from "./CashOutDialog.module.scss";

function CashOutDialog({
  saveChanges,
  cashOutStep,
  setCashOutStep,
  isDialogOpen,
  setIsDialogOpen,
  mutationLoading,
  cashOurError,
  setCashOurError,
  amountDue,
  bank
}) {
  const history = useHistory();

  function closeDialog() {
    setIsDialogOpen(false);
    setCashOutStep(0);
    setCashOurError("");
  }

  if (bank.digits && !bank.arePayoutsEnabled) {
    return (
      <Dialog
        icon="dollar"
        title="Cash Out"
        onClose={closeDialog}
        canOutsideClickClose={false}
        isOpen={isDialogOpen}
        className={styles.cashOutDialog}
      >
        <form>
          <div className={Classes.DIALOG_BODY}>
            <FormInfo>
              Additional information is required to be able to cash out to your linked bank account.
            </FormInfo>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button minimal onClick={closeDialog} type="button">Cancel</Button>
              <Button
                onClick={() => {
                  window.location = bank.stripeRequirementLink;
                }}
                type="button"
                intent={Intent.PRIMARY}
              >
                Update
              </Button>
            </div>
          </div>
        </form>
      </Dialog>
    )
  }

  return (
    <Dialog
      icon="dollar"
      title="Cash Out"
      onClose={closeDialog}
      canOutsideClickClose={false}
      isOpen={isDialogOpen}
      className={styles.cashOutDialog}
    >
      {cashOurError && (
        <Callout
          icon="error"
          intent={Intent.DANGER}
          title={"Cash Out Transaction failed."}
        >
          {cashOurError}
        </Callout>
      )}
      {cashOutStep === 0 && (
        <form>
          <div className={Classes.DIALOG_BODY}>
            <FormGroup
              label="Available to Cash Out"
              labelFor="availableCashOut"
            >
              <InputGroup
                id="availableCashOut"
                type="text"
                disabled
                autoCapitalize="none"
                autoCorrect="false"
                value={`$${amountDue.toFixed(2)}`}
              />
            </FormGroup>
            <FormInfo>
              Take your available balance and transfer to your linked bank account.
            </FormInfo>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button onClick={closeDialog} type="button" minimal>
                Cancel
              </Button>
              <Button
                onClick={() => setCashOutStep(1)}
                type="button"
                intent={Intent.PRIMARY}
              >
                Next
              </Button>
            </div>
          </div>
        </form>
      )}
      {cashOutStep === 1 && (
        <form>
          <div className={Classes.DIALOG_BODY}>
            <FormGroup label="Cash Out to this Account">
              <InputGroup
                value={bank.digits ? `Account Ending ${bank.digits}` : "NA"}
                disabled
                rightElement={
                  <Button
                    text={!bank.digits ? "Add" : "Change"}
                    onClick={() => history.push("/settings/bank-account")}
                  />
                }
              />
            </FormGroup>
            <FormInfo>
              <b>{`$${amountDue.toFixed(2)}`}</b> will be sent to this account.
              The transfer is processed through Stripe and typically takes about
              7 business days.
            </FormInfo>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button onClick={closeDialog} type="button" minimal>
                Cancel
              </Button>
              <Button
                type="button"
                loading={mutationLoading}
                onClick={() => {
                  saveChanges();
                }}
                disabled={!bank.digits}
                intent={Intent.PRIMARY}
              >
                Cash Out
              </Button>
            </div>
          </div>
        </form>
      )}
    </Dialog>
  );
}

export default CashOutDialog;
